

import '../pages/Gachapon.scss';
import { useLottie } from "lottie-react";
import { useEffect, useState } from "react";

import gachaponProcessing from "./gachapon_processing.json";


const GachaponStatus = () => {
    
    const options = {
      animationData: gachaponProcessing,
      loop: true,
      autoplay: true,
      onComplete: () => {
        
      }
    };
  
    const { View, play } = useLottie(options);

    useEffect(() => {
        play()
    }, [play])

    return (<div className="Gachapon--Processing-Animation">
        {View}
    </div>);
  };


  const GachaponProcessing = () => {
    


      return (
        <div className={`Gachapon--Processing `}>
            <div className={`Gachapon--Processing--Content`}>
                <GachaponStatus/>
                <div className="Gachapon--Processing--Title">Processing payment...</div>
                <div className="Gachapon--Processing--Text">It might take a few seconds.. Hold tight!</div>
            </div>
            
        </div>
      )

  }

  export default GachaponProcessing;